
import { useMapStore } from '@/composables'
export default {
    name: 'TripDetails',
    setup() {
        const { distance, duration }  = useMapStore()
        return {
            distance, duration
        }
    }
}
